import { Controller } from "@hotwired/stimulus"
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  static targets = ["currencyInput"]
  static values = { allowNegative: { type: Boolean, default: false } }

  connect() {
    this.initInputs()
  }

  initInputs() {
    if (this.hasCurrencyInputTarget) {
      if (this.currencyInputTargets.length > 0) {
        this.currencyInputTargets.forEach(input => {
          this.initSingleInput(input)
        })
      } else {
        this.initSingleInput(this.currencyInputTarget)
      }
    }
  }

  initSingleInput(input) {
    if (!input.classList.contains("autonumeric-initialized")) {
      const minimumValue = this.allowNegativeValue ? '-1000000' : '0.00'
      const config = new AutoNumeric(input, {
        decimalPlaces: 2,
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        allowDecimalPadding: 'true',
        minimumValue: minimumValue,
        maximumValue: '1000000',
        emptyInputBehavior: 'null'
      })
      input.classList.add("autonumeric-initialized")

      const form = input.closest("form")
      if (form) {
        form.addEventListener("submit", () => {
          input.value = config.getNumber()
        })
      }
    }
  }
}